export default __webpack_public_path__ + "static/media/total-scan-qr.dbb5245e.svg";